import type { SensorType } from "../domain";
import type { SensorAssignmentListItemDto } from "../data";

// `GET /sensors` -- Sensors Management list. No real backend endpoint
// exists yet (see SensorAssignmentsListQuery); enough rows and spread to
// exercise real pagination/search/sort/filter.
const SENSOR_TYPES: readonly SensorType[] = [
  "WEIGHT",
  "TEMPERATURE",
  "DOOR_STATUS",
  "IBUTTON",
  "PTO",
  "SEAT_BELT",
  "REFRIGERATOR_STATE",
  "HEADLIGHTS",
  "SOS",
  "RFID",
];

const WEIGHT_FORMULA_TYPES = ["NONE", "SUM", "PERCENT"] as const;

const SENSOR_ACCOUNTS = [
  {
    id: "sensor-company-01",
    nameEn: "Jeddah Events Security",
    nameAr: "أمن الفعاليات جدة",
  },
  {
    id: "sensor-company-02",
    nameEn: "Riyadh Facilities Security",
    nameAr: "أمن المنشآت الرياض",
  },
  {
    id: "sensor-company-03",
    nameEn: "Madinah Security Services",
    nameAr: "خدمات الأمن المدينة المنورة",
  },
  {
    id: "sensor-company-04",
    nameEn: "Comprehensive Protection Insurance",
    nameAr: "تأمين الحماية الشاملة",
  },
  {
    id: "sensor-company-05",
    nameEn: "Dammam Facilities Protection",
    nameAr: "حماية المنشآت الدمام",
  },
];

const sensorDate = (index: number) =>
  `2026-${String((index % 9) + 1).padStart(2, "0")}-${String((index % 27) + 1).padStart(2, "0")}T09:00:00.000Z`;

function sensorName(sensorType: SensorType, index: number): string {
  const label = sensorType
    .toLowerCase()
    .split("_")
    .map((word) => word[0]!.toUpperCase() + word.slice(1))
    .join(" ");
  return `${label} Sensor ${String(index)}`;
}

export const sensorAssignmentListItemFixtures: readonly SensorAssignmentListItemDto[] =
  Array.from({ length: 15 }, (_, offset) => {
    const index = offset + 1;
    const sensorType = SENSOR_TYPES[offset % SENSOR_TYPES.length]!;
    const isWeight = sensorType === "WEIGHT";
    const isRfid = sensorType === "RFID";
    const configType = isWeight
      ? WEIGHT_FORMULA_TYPES[offset % WEIGHT_FORMULA_TYPES.length]!
      : null;

    return {
      id: `sensor-assignment-${String(index).padStart(2, "0")}`,
      sensorType,
      name: sensorName(sensorType, index),
      configType,
      minValue: isWeight ? 1000 * (index % 5) : null,
      maxValue: isWeight ? 5000 + 1000 * (index % 5) : null,
      unit: isWeight ? "KGs" : null,
      tagLength: isRfid ? 2 + (index % 3) : null,
      sensorConfig: {
        id: `sensor-config-${String(index).padStart(2, "0")}`,
        deviceCount: 1,
      },
      device: {
        id: `sensor-device-${String(index).padStart(2, "0")}`,
        code: `DEV-${String(100000 + index)}`,
        imei: `8634120455${String(1200 + index)}`,
      },
      account: SENSOR_ACCOUNTS[offset % SENSOR_ACCOUNTS.length]!,
      createdAt: sensorDate(index),
    };
  });
